App.directive('appPagination', function(){

    return {
        templateUrl: '/app/views/partials/pagination.html' + (CONFIG && CONFIG.appVersion ? '?v=' + CONFIG.appVersion : ''),
        controller: 'PaginationController',
        restrict: 'E',
        replace: true,
        scope: { 
            pages: '=pages',
            current: '=current',
            table: '=table',
          }
    };
})